/* eslint-disable array-callback-return */
import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { snapshot, useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { CheckboxIcon } from "@aureskonnect/react-ui";
import { mutate } from "swr";
import { toast } from "react-toastify";
import { uuid } from "uuidv4";

import {
    setGlobalDataIsUpdated,
    setIsModalOpened,
    setOverLaps,
    store,
    setIsValidationNumToTake,
    setIsValidationPriceTheSpot,
    setIsValidationPriceToTake,
    setIsValidationPeriodToTake,
    setIsValidationNumDelivrey,
    setIsValidationNumTheSpot,
    setDuration,
    setKey,
} from "../store";
import {
    store as device,
    setActions,
    setIsActionsClicked,
    setIsEdited,
} from "../GeneralConfigC&C/City/store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { store as storeGlobal } from "@components/VerticalLayout/store";

import { templateStore } from "@pages/Applications/C&C/C&CSetup/templateStore";
import { clearFileStore, fileStore } from "../fileStore";
import "./index.css";
import {
    // buildLocalOptionComposite,
    buildSavedData,
    getApkTemplateDateModification,
    getPattern,
    isClosed,
    uploadApkTemplate,
    validateFormData,
} from "./hooks";
import { useSelector } from "react-redux";

type PropsType = {
    children: React.ReactNode;
    title: string;
    selectedRows: any;
};

export function ModalWrapper({
    children,
    title = "",
    selectedRows,
}: PropsType): JSX.Element {
    const { oneShop } = useSnapshot(storeGlobal);
    const UPDATE_APK = selectedRows[0]?.Apk && !oneShop ? true : false;
    const { t } = useTranslation();
    let isShopClosed: boolean = false;
    const {
        isModalOpened,
        itemActivation,
        ItemSalesMethods,
        ItemPayementChoice,
        loyaltyAccount,
        options,
        orders,
        hourOfUse,
        isAddCity,
        isAddZone,
        isErreur,
        overLaps,
        optionComposite,
        isValidationNumTheSpot,
        isValidationNumToTake,
        isValidationPriceTheSpot,
        isValidationPriceToTake,
        isValidationPeriodToTake,
        isValidationNumDelivrey,
        fuseau_horaire,
    } = useSnapshot(store);
    const { isActionsClicked, isEdited } = useSnapshot(device);
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [IsLoading, setIsLoading] = useState(false);
    let schema: any = useSelector(
        (state: any) => state.global.entityDetails.franchise_schema
    );
    const toggle = () => {
        if (isEdited === true) {
            setIsActionsClicked(!isActionsClicked);
            setActions(() => {
                setIsEdited(false);
                setIsModalOpened(!isModalOpened);
                setGlobalDataIsUpdated(true);
                setIsValidationNumToTake(false);
                setIsValidationPriceTheSpot(false);
                setIsValidationPriceToTake(false);
                setIsValidationPeriodToTake(false);
                setIsValidationNumDelivrey(false);
                setIsValidationNumTheSpot(false);
                setDuration("");
            });
        } else {
            setIsModalOpened(!isModalOpened);
            setGlobalDataIsUpdated(true);
            setIsValidationNumToTake(false);
            setIsValidationPriceTheSpot(false);
            setIsValidationPriceToTake(false);
            setIsValidationPeriodToTake(false);
            setIsValidationNumDelivrey(false);
            setIsValidationNumTheSpot(false);
            setDuration("");
        }
    };

    isShopClosed = isClosed(hourOfUse);

    async function ccSetup() {
        const isValidation =
            isValidationNumTheSpot ||
            isValidationNumToTake ||
            isValidationPriceTheSpot ||
            isValidationPriceToTake ||
            isValidationPeriodToTake ||
            isValidationNumDelivrey;
        // const localOptionComposite = buildLocalOptionComposite(
        //     optionComposite,
        //     selectedRows
        // );
        const pattern = getPattern(orders, selectedRows, t);
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/setup/c&c`;
        let etat: number = itemActivation[0].active === true ? 1 : 0;
        const savedData = await buildSavedData({
            selectedRows,
            schema,
            etat,
            itemActivation,
            ItemSalesMethods,
            ItemPayementChoice,
            options,
            loyaltyAccount,
            hourOfUse,
            localOptionComposite: optionComposite,
            fuseau_horaire,
            orders,
            pattern,
        });

        if (isValidation) {
            setIsLoading(false);
        } else {
            try {
                mutate(
                    apiUrlAdd,
                    await fetch(apiUrlAdd, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(savedData),
                    }).then((result: any) => {
                        if (result.error === true) {
                            throw Error(result.message);
                        }
                        setDuration("");
                        setKey(uuid());
                        setIsLoading(false);
                        setIsValidationNumToTake(false);
                        setIsValidationPriceTheSpot(false);
                        setIsValidationPriceToTake(false);
                        setIsValidationPeriodToTake(false);
                        setIsModalOpened(!isModalOpened);
                        setGlobalDataIsUpdated(true);
                    })
                );
            } catch (e: any) {
                toast.error(`${t("There's an error")}!`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        }
    }

    async function handleSetup() {
        if (!IsLoading) {
            setIsLoading(false);
            const template: any = snapshot(templateStore);
            const formData = new FormData();

            try {
                const valid = await getApkTemplateDateModification(
                    template,
                    selectedRows[0].iuudApk
                );
                if (!valid) {
                    toast.warning(
                        t(
                            "The template has been modified by another user. The changes you made will not be saved."
                        ),
                        {
                            position: "top-center",
                            autoClose: 2000,
                            theme: "colored",
                        }
                    );

                    clearFileStore();
                    setIsModalOpened(!isModalOpened);
                    return 0;
                }

                formData.append(
                    "globalTemplate",
                    JSON.stringify(template.template)
                );

                Object.entries(fileStore).forEach(([key, file]) => {
                    if (file instanceof File) {
                        formData.append(key, file);
                    }
                });

                let isValid = true;
                if (!UPDATE_APK) {
                    isValid = await validateFormData(
                        t,
                        ItemSalesMethods,
                        ItemPayementChoice,
                        optionComposite,
                        isShopClosed,
                        orders,
                        overLaps,
                        isErreur,
                        ccSetup
                    );
                }
                if (isValid) {
                    const result = await uploadApkTemplate(
                        selectedRows,
                        formData
                    );
                    if (!result) {
                        throw new Error("Upload failed");
                    }
                    toast.success(`${t("Template saved successfully")!}`, {
                        position: "top-center",
                        autoClose: 2000,
                        theme: "colored",
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        icon: (
                            <CheckboxIcon height={25} width={25} fill="white" />
                        ),
                    });
                    clearFileStore();
                    setIsModalOpened(!isModalOpened);
                }
                setIsLoading(true);
            } catch (error) {
                setIsLoading(true);
                console.error("Upload failed:", {
                    error: error,
                });
            }
        }
    }

    useEffect(() => {
        let overLap =
            overLaps !== undefined && JSON.parse(JSON.stringify(overLaps));
        JSON.parse(JSON.stringify(hourOfUse)).map(
            (element: any, key: number) => {
                if (
                    element.HeureDebut_Matin === "" &&
                    element.HeureFin_Matin !== ""
                ) {
                    // eslint-disable-next-line no-whitespace-before-property
                    overLap[key].inputDebut_Matin = true;
                } else if (
                    element.HeureDebut_Matin !== "" &&
                    element.HeureFin_Matin === ""
                ) {
                    // eslint-disable-next-line no-whitespace-before-property
                    overLap[key].inputFin_Matin = true;
                } else if (
                    element.HeureDebut_soir !== "" &&
                    element.HeureFin_soir === ""
                ) {
                    // eslint-disable-next-line no-whitespace-before-property
                    overLap[key].inputFin_Soir = true;
                } else if (
                    element.HeureDebut_soir === "" &&
                    element.HeureFin_soir !== ""
                ) {
                    // eslint-disable-next-line no-whitespace-before-property
                    overLap[key].inputDebut_Soir = true;
                } else {
                    overLap[key].inputDebut_Soir = false;
                    overLap[key].inputFin_Soir = false;
                    overLap[key].inputDebut_Matin = false;
                    overLap[key].inputFin_Matin = false;
                }
            }
        );
        setOverLaps(overLap);
    }, [hourOfUse, overLaps]);

    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                toggle={toggle}
                isOpen={isModalOpened}
                className="modal-wrapper__clz"
            >
                <ModalHeader
                    toggle={toggle}
                    className="text-uppercase modal-wrapper-title__clz"
                >
                    {title}
                </ModalHeader>
                <ModalBody className="p-0">{children}</ModalBody>
                <ModalFooter>
                    {!isAddCity && !isAddZone ? (
                        <CustomMainColorButton
                            className="w-20"
                            rounded
                            color={mainColor}
                            onClick={() => {
                                handleSetup();
                            }}
                        >
                            {t("Save")}
                        </CustomMainColorButton>
                    ) : (
                        <CustomMainColorButton className="style-buttom__clz" />
                    )}
                </ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
